import { Button } from 'beam/dist/Button'
import { Checkbox } from 'beam/dist/Checkbox'
import { Dialog, DialogActions, DialogContent, DialogTitle } from 'beam/dist/Dialog'
import { FormControlLabel } from 'beam/dist/Form'
import { Typography } from 'beam/dist/Typography'
import moment from 'moment-timezone'
import { useState, Fragment } from 'react'
import { useTranslation } from 'react-i18next'
import { useMaintenanceMessageApi } from './useMaintenanceMessageApi'
import { ErrorSnackbar } from '../ErrorSnackbar'
import { useUser } from '../../Permissions'

// this localStorage key is also used in wfo-ui
const LOCAL_STORAGE_KEY_HIDE_MESSAGE = 'hideMaintenanceNotificationMessageWithId'
const TIMESTAMP_LABEL_FORMAT = 'MM/DD/YYYY h:mma zz'

export function MaintenanceNotificationDialog() {
  const [isLoading, message, error] = useMaintenanceMessageApi()
  const [closedErrorSnackbar, setClosedErrorSnackbar] = useState(false)
  const [closedMessageDialog, setClosedMessageDialog] = useState(false)
  const [doNotShowAgain, setDoNotShowAgain] = useState(false)
  const { t } = useTranslation()
  const user = useUser()
  const confirmNotification = () => {
    setClosedMessageDialog(true)
    if (doNotShowAgain) {
      localStorage.setItem(LOCAL_STORAGE_KEY_HIDE_MESSAGE, message.messageCreation)
    }
  }
  if (isLoading) return null
  if (error)
    return (
      <ErrorSnackbar
        open={!closedErrorSnackbar}
        message={
          <Fragment>
            <div>{(error && error.data && error.data.errorMessage) || t('serverError')}</div>
            <div>{error && error.data && error.data.requestId ? `${t('requestID')}: ${error.data.requestId}` : ''}</div>
          </Fragment>
        }
        onClose={() => setClosedErrorSnackbar(true)}
      />
    )
  if (!message) return null
  const hideMaintenanceNotificationMessageWithId = localStorage.getItem(LOCAL_STORAGE_KEY_HIDE_MESSAGE)
  const previouslyHidCurrentNotification =
    hideMaintenanceNotificationMessageWithId &&
    hideMaintenanceNotificationMessageWithId === message.messageCreation.toString()
  if (previouslyHidCurrentNotification) return null
  const isBefore = Date.now().valueOf() >= message.notificationStart && Date.now().valueOf() < message.maintenanceStart
  const isDuring = Date.now().valueOf() >= message.maintenanceStart && Date.now().valueOf() < message.maintenanceEnd
  return (
    <Dialog open={(isBefore || isDuring) && !closedMessageDialog} onClose={() => setClosedMessageDialog(true)}>
      <DialogTitle>{message.title}</DialogTitle>
      <DialogContent>
        <Typography display="block">{isBefore ? message.messageBefore : message.messageDuring}</Typography>
        <Typography display="block">
          {t('beginTimeLabel', {
            0: moment.tz(message.maintenanceStart, user.timezoneString).format(TIMESTAMP_LABEL_FORMAT),
          })}
        </Typography>
        <Typography display="block">
          {t('endTimeLabel', {
            0: moment.tz(message.maintenanceEnd, user.timezoneString).format(TIMESTAMP_LABEL_FORMAT),
          })}
        </Typography>
        <FormControlLabel
          control={<Checkbox checked={doNotShowAgain} onChange={() => setDoNotShowAgain(!doNotShowAgain)} />}
          label={t('doNotShowAgain')}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={confirmNotification}>{t('ok')}</Button>
      </DialogActions>
    </Dialog>
  )
}
